export const COOKIE_NAME_RP = 'Rp';
export const COOKIE_NAME_RZ = 'Rz';
export const SURVEY_EXPIRATION_NAME = 'REX-SURVEY-EXPIRATION-TIME';
export const SURVEY_STATE_NAME = 'REX-SURVEY-STATE';
export const SURVEY_STATE_VALUE_ANSWERED = 'ANSWERED';
export const SURVEY_STATE_VALUE_DECLINED = 'DECLINED';
export const SURVEY_API_ENDPOINT_BASE = 'https://form.rakuten.co.jp/ans/apply/';
// export const SURVEY_ID = 30284;

/**
 * NPS score により Inquiry checkbox 設問を切り替える分岐点 - 未満チェックを行う
 * @type {number}
 */
export const NPS_SCORE_INTERSECTION = 4;

export const FOOTER_NOTE = {
  text:
    'お客様よりご提供いただく情報はサービス向上のためご利用させていただきます。',
  link: 'https://privacy.rakuten.co.jp/',
  htmlText:
    "お客様よりご提供いただく情報はサービス向上のためご利用させていただきます。個人情報の取り扱いに関しては<a href='https://corp.rakuten.co.jp/privacy/link.html' target='_blank'>こちら</a>をご確認ください。",
};

export const EMBEDDED_POINT = 'rexSurveyEmbedded';

export default {
  COOKIE_NAME_RP,
  COOKIE_NAME_RZ,
  SURVEY_EXPIRATION_NAME,
  SURVEY_STATE_NAME,
  SURVEY_STATE_VALUE_ANSWERED,
  SURVEY_STATE_VALUE_DECLINED,
  SURVEY_API_ENDPOINT_BASE,
  // SURVEY_ID,
  FOOTER_NOTE,
  EMBEDDED_POINT,
};



// WEBPACK FOOTER //
// ./src/phase2/survey/app/constants.js